"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingMethodACH = void 0;

var Interfaces_1 = require("../Interfaces");

var Errors_1 = require("../Errors");

var BillingMethodACH =
/** @class */
function () {
  function BillingMethodACH(achInfo) {
    this.bankAccountNumber = BillingMethodACH.formatBankAccountNumber(achInfo.bankAccountNumber);
    this.bankRoutingNumber = BillingMethodACH.formatBankRoutingNumber(achInfo.bankRoutingNumber);
  }

  BillingMethodACH.formatBankAccountNumber = function (bankAccountNumber) {
    BillingMethodACH.isValidBankAccountNumber(bankAccountNumber);
    return bankAccountNumber;
  };

  BillingMethodACH.isValidBankAccountNumber = function (bankAccountNumber) {
    if (!/^\d{4,17}$/.test(bankAccountNumber)) {
      throw new Errors_1.PaymentValidationError("Bank account number contains illegal characters or has illegal format. Only numbers are allowed", Interfaces_1.PaymentErrorShortCodes.invalid_bank_account_number);
    }

    return true;
  };

  BillingMethodACH.formatBankRoutingNumber = function (bankRoutingNumber) {
    BillingMethodACH.isValidBankRoutingNumber(bankRoutingNumber);
    return bankRoutingNumber;
  };

  BillingMethodACH.isValidBankRoutingNumber = function (bankRoutingNumber) {
    if (!/^\d{6,9}$/.test(bankRoutingNumber)) {
      throw new Errors_1.PaymentValidationError("Bank routing number contains illegal characters or has illegal format. Only numbers are allowed", Interfaces_1.PaymentErrorShortCodes.invalid_bank_routing_number);
    }

    return true;
  };

  return BillingMethodACH;
}();

exports.BillingMethodACH = BillingMethodACH;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/BillingMethods/billingmethod.ach.js